import { useEffect, useState } from "react";
import { fetcher, Methods } from "../api";

export const useFetchCity = () => {
  const [searchCityValue, setSearchCityValue] = useState("");
  const [cities, setCities] = useState<any>([]);

  const fetchCity = (query: string) => {
    return fetcher({
      method: Methods.get,
      url: `/profile/autocomplete/city/?q=${query}`
    }).then((res) => {
      return res.map((each: any, index: number) => {
        return {
          ...each,
          id: index
        }
      });
    }).catch(() => {
      return [];
    })
  }
  
  useEffect(() => {
    fetchCity(searchCityValue).then((res) => {
      setCities(res.map((each: any) => {
        return {
          id: each.id,
          name: each.name,
          value: each.name
        };
      }));
    });
  }, [searchCityValue]);

  return {
    cities,
    searchCityValue,
    setSearchCityValue
  };
};
